import React from 'react';
import { Tabs, Badge } from 'antd';
import './page.css';

/**
 * First-level page navigation: thin wrapper over antd Tabs. An item's optional `count` renders as
 * a Badge (never "(n)" text). Everything else passes straight through to antd Tabs.
 */
export const buildPageTabItems = (items = []) =>
  items.map(({ count, label, ...rest }) => ({
    ...rest,
    label: (
      <span className="pl-page-tabs__label">
        {label}
        {count !== undefined && count !== null ? (
          <Badge count={count} showZero overflowCount={999} data-testid={`page-tab-count-${rest.key}`} />
        ) : null}
      </span>
    ),
  }));

const PageTabs = ({ items, className = '', ...rest }) => (
  <Tabs className={`pl-page-tabs ${className}`.trim()} items={buildPageTabItems(items)} {...rest} />
);

export default PageTabs;
